import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";

import { Button } from '../Button';
import { useInduction } from "../../hooks/useInduction";

import { Container } from "./styles";

interface Props {
    benefitName: string;
}

export function LgpdInformation({benefitName}: Props) {

    return (
        <Container>
            <div>
                <p>
                    <strong>CADASTRO REALIZADO COM SUCESSO!</strong>
                </p>               
                <p>
                    É necessário obter o consentimento imediato do paciente para seguir com a compra via {benefitName}
                </p>
            </div>
        </Container>
    )
}